export default "__VITE_ASSET__CBtF3JUc__"